import { ServiceConstants } from './serviceSelection.constants'
import { IServiceState } from './serviceSelection.types'

export const initialServiceState: IServiceState = {
  services: [],
  isLoading: false,
}

export function serviceReducer(state: IServiceState = initialServiceState, action: any): IServiceState {
  switch (action.type) {
    case ServiceConstants.SET_IS_LOADING:
      return { ...state, isLoading: action.isLoading }
    case ServiceConstants.SET_SERVICES_LIST:
      return { ...state, services: action.servicesList }
    default:
      return state
  }
}
